export const MESSAGE_CHANGE_EMAIL = 'CHANGE_EMAIL';
export const MESSAGE_CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const MESSAGE_DISABLE_SPINNER = 'DISABLE_SPINNER';
export const MESSAGE_GET_AUTH_TOKENS = 'GET_AUTH_TOKENS';
export const MESSAGE_GET_ELEVATE_TOKENS = 'GET_ELEVATE_TOKENS';
export const MESSAGE_GO_TO_ROUTER = 'GO_TO_ROUTER';
export const MESSAGE_OPEN_URL_IN_BROWSER = 'OPEN_URL_IN_BROWSER';
export const MESSAGE_REFRESH_ROUTER = 'REFRESH_ROUTER';
export const MESSAGE_REMOVE_HTTP_HEADER_AUTHORIZATION_TOKEN =
  'REMOVE_HTTP_HEADER_AUTHORIZATION_TOKEN';
export const MESSAGE_REQUEST_HTTP = 'REQUEST_HTTP';
export const MESSAGE_RESPOND_HTTP = 'RESPOND_HTTP';
export const MESSAGE_RESTART_ROUTER = 'RESTART_ROUTER';
export const MESSAGE_SET_APP_VERSION = 'SET_APP_VERSION';
export const MESSAGE_SET_APP_VERSION_STRING = 'SET_APP_VERSION_STRING';
export const MESSAGE_SET_AUTH_TOKENS = 'SET_AUTH_TOKENS';
export const MESSAGE_SET_ELEVATE_TOKENS = 'SET_ELEVATE_TOKENS';
export const MESSAGE_SET_LOCALE = 'SET_LOCALE';
export const MESSAGE_SET_HTTP_HEADER_ACCEPT_LANGUAGE =
  'SET_HTTP_HEADER_ACCEPT_LANGUAGE';
export const MESSAGE_SET_HTTP_HEADER_AUTHORIZATION =
  'SET_HTTP_HEADER_AUTHORIZATION';
export const MESSAGE_SETUP_MFA = 'SETUP_MFA';
export const MESSAGE_SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const MESSAGE_SIGN_IN = 'SIGN_IN';
export const MESSAGE_SIGN_OUT = 'SIGN_OUT';
export const MESSAGE_SIGN_UP = 'SIGN_UP';
